import React, { memo } from "react";
import { MenuItem } from "../menuItem";
import { clickToLinkHandler } from "../../../../helpers/utils";

type MenuItemEntry = {
  name: string;
  link: string;
  dataTestId: string;
  subItems?: MenuItemEntry[];
};

const menuItems: MenuItemEntry[] = [
  {
    name: "Deal Information",
    link: "deal-information",
    dataTestId: "deal-summary-link",
  },
  {
    name: "Company Information",
    link: "company-information",
    dataTestId: "company-information-link",
  },
  {
    name: "Investors",
    link: "investors",
    dataTestId: "investors-link",
  },
  {
    name: "Documents",
    link: "documents",
    dataTestId: "documents-link",
  },
  {
    name: "Closing",
    link: "signatures",
    dataTestId: "closing-link",
    subItems: [
      {
        name: "Signatures and Wire Tracker",
        link: "signatures",
        dataTestId: "signatures-link",
      },
      {
        name: "Your Signatures",
        link: "your-signatures",
        dataTestId: "your-signatures-link",
      },
    ],
  },
];

type MenuInnerListProps = {
  orgId: number;
  dealId: number;
  pathname: string;
};

const MenuInnerList = ({ orgId, dealId, pathname }: MenuInnerListProps) => {
  return (
    <div className={`deals-menu-container ${!dealId ? "new-deal" : ""}`}>
      <ol>
        {menuItems.map((item, key) => {
          const lastSegment = pathname.substring(pathname.lastIndexOf("/") + 1);

          let isActive = pathname.indexOf(item.link) > -1;

          if (item.subItems) {
            for (const subItem of item.subItems) {
              isActive = pathname.indexOf(subItem.link) > -1;
              if (isActive === true) break;
            }
          }

          return (
            <React.Fragment key={"menu_item_" + key}>
              {item.link !== "documents" && (
                <MenuItem
                  dataTestId={item.dataTestId}
                  name={item.name}
                  subItems={item.subItems}
                  isActive={isActive}
                  isExactPathname={lastSegment === item.link}
                  onClick={() => {
                    if (dealId) {
                      clickToLinkHandler(
                        "/" + orgId + "/deals/" + dealId + "/edit/" + item.link
                      );
                    }
                  }}
                />
              )}
              {item.link === "documents" && (
                <MenuItem
                  dataTestId={item.dataTestId}
                  name={item.name}
                  subItems={item.subItems}
                  isActive={isActive}
                  isExactPathname={lastSegment === item.link}
                  onClick={() => {
                    if (dealId) {
                      clickToLinkHandler(`/${orgId}/deals/${dealId}/documents`);
                    }
                  }}
                />
              )}

              {isActive && item.subItems && item.subItems.length && (
                <div className="sub-items-container">
                  <ol>
                    {item.subItems.map((subItem, index) => {
                      return (
                        <MenuItem
                          dataTestId={subItem.dataTestId}
                          key={"menu_item_" + key + "." + index}
                          name={subItem.name}
                          subItem={true}
                          isActive={lastSegment === subItem.link}
                          isExactPathname={lastSegment === subItem.link}
                          onClick={() => {
                            if (dealId) {
                              clickToLinkHandler(
                                "/" +
                                  orgId +
                                  "/deals/" +
                                  dealId +
                                  "/edit/" +
                                  subItem.link
                              );
                            }
                          }}
                        />
                      );
                    })}
                  </ol>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </ol>
    </div>
  );
};

export const MenuList = memo(MenuInnerList);
